import { render, staticRenderFns } from "./start-eidas-journey.vue?vue&type=template&id=b7ffe304&scoped=true"
import script from "./start-eidas-journey.vue?vue&type=script&lang=ts"
export * from "./start-eidas-journey.vue?vue&type=script&lang=ts"
import style0 from "./start-eidas-journey.vue?vue&type=style&index=0&id=b7ffe304&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7ffe304",
  null
  
)

export default component.exports